module.exports = __webpack_public_path__ + "static/img/honor8.899ebbb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/honor/honor8.png
// module id = KsZN
// module chunks = 0